var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["onboarding-overlay", { mobile: _vm.isMobile(_vm.$mq) }],
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.closeOverlay($event)
        }
      }
    },
    [
      _c("div", { staticClass: "modal", style: _vm.modalStyles }, [
        _c("h3", { staticClass: "text" }, [
          _vm._v(
            "We’ll begin in the first lesson of " + _vm._s(_vm.firstChapterName)
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }